module.exports = __webpack_public_path__ + "static/img/15062B_1_R_20200922_fit.cf601c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15062B_1_R_20200922_fit.png
// module id = 5RfH
// module chunks = 0